import React, { Component } from 'react';
import { Col, Container, Row } from 'reactstrap';
import YourBlogs from './components/YourBlogs';
import WeeklyStat from './components/YourPower';
import { connect } from 'react-redux';
import { fetchAccountStats } from '../../redux/actions/steemAccountActions';
import Reputation from './components/Reputation';
import Profile from './components/Profile';
import AssetIndicator from './components/AssetIndicator';
import { withRouter } from 'react-router-dom';
import ImproveYourProfile from './components/ImproveYourProfile';
import SupportUs from './components/SupportUs';
import {withTranslation} from "react-i18next";

class YourAccount extends Component {

  render() {

    const { t } = this.props;

    return (
      <Container className="dashboard">
        <Row>
            <Col md={12}>
                <h3 className="page-title">{t('overview.title')}</h3>
            </Col>
        </Row>
        <Row>
          <WeeklyStat
            voting_manabar={this.props.steemAccount.voting_manabar}
            downvote_manabar={this.props.steemAccount.downvote_manabar}
            resource_credits={this.props.steemAccount.resource_credits}
            onRefresh={() => { this.props.onFetchAccountStats(this.props.auth.username) }}
            loading={this.props.steemAccount.loading}
          />
          <Reputation
            reputation={this.props.steemAccount.reputation}
            onRefresh={() => { this.props.onFetchAccountStats(this.props.auth.username) }}
            loading={this.props.steemAccount.loading}
          />
          <Profile
            blogs_count={this.props.blogs.blogs.length}
            username={this.props.auth.username}
            post_count={this.props.steemAccount.post_count}
            about={this.props.steemAccount.about}
            website={this.props.steemAccount.website}
          />
          <Col xl={2} lg={6} md={12} xs={12} >
            <Row>
              <AssetIndicator
                asset="Hive Power"
                color_name="red"
                amount={this.props.steemAccount.hive_power}
                pending={this.props.steemAccount.reward_hive_power}
              />

              <AssetIndicator
                asset="HIVE"
                color_name="green"
                amount={this.props.steemAccount.hive}
                pending={this.props.steemAccount.reward_hive}
              />

              <AssetIndicator
                asset="HBD"
                color_name="blue"
                amount={this.props.steemAccount.hbd}
                pending={this.props.steemAccount.reward_hbd}
              />
            </Row>
          </Col>

        </Row>
        <Row>
          <YourBlogs />
          <ImproveYourProfile />
          <SupportUs />
        </Row>
      </Container>)
  }

}


const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    steemAccount: state.steemAccount,
    blogs: state.blogs
  }
}

const mapsDispatchToProps = (dispatch) => {
  return {
    onFetchAccountStats: (username) => dispatch(fetchAccountStats(username))
  }
}

export default withRouter(connect(mapStateToProps, mapsDispatchToProps)(withTranslation('dashboard')(YourAccount)));
